
document.addEventListener('DOMContentLoaded', function () {
  // Function to dynamically load a script
  function loadScript(src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = src;
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  // Attach event listeners to elements
  function attachClickEvent(selector, scriptSrc) {
    document.querySelectorAll(selector).forEach(function (element) {
      element.addEventListener('click', function () {
        loadScript(scriptSrc);
      });
    });
  }

  // Initialize storepoint for store-drawer
  var scriptUrl = 'https://cdn.storepoint.co/api/v1/js/160ee952367f27.js';
  attachClickEvent('[aria-controls="store-drawer"]', scriptUrl);
});